var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-gototop",class:{ uWhite: _vm.$route.name==='kodateDetail' || _vm.$route.name==='MemberLogin' }},[_c('button',{on:{"click":_vm.clickSmoothScroll}},[_vm._v("ページTOPへ")])])}
var staticRenderFns = []

export { render, staticRenderFns }